module.exports = __webpack_public_path__ + "img/directions_run.4bc5b562.svg";